export default __webpack_public_path__ + "static/media/12-red-tree.9237fdd5.JPG";